import React, { ReactElement } from 'react';
import Chip from '../chip/chip.component';
import StructureService from '../../services/structure-service';
import useCurrentUserPermissions from '../../hooks/use-current-user-permissions';

const ChipLink: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDisabled,
    withDelete,
    withImageOffset,
    label,
    imageLink,
    permission,
    permissions,
    onClick,
    onDelete,
    children,
  } = props;

  const permissionList: string[] = useCurrentUserPermissions();

  const chipPermissions: string[] = permission ? [permission] : (permissions || []);
  const isAllowed: boolean = chipPermissions && chipPermissions.length
    ? chipPermissions.reduce((isAllowed: boolean, permissionItem: string): boolean => (
      isAllowed || StructureService.checkPermission(permissionItem, permissionList)
    ), false) : true;

  return (
    <Chip
      isDisabled={isDisabled}
      withDelete={withDelete}
      withImageOffset={withImageOffset}
      label={label}
      imageLink={imageLink}
      onClick={!isDisabled && isAllowed ? onClick : undefined}
      onDelete={onDelete}
    >
      {children}
    </Chip>
  );
});

export default ChipLink;
